import { enqueueSnackbar } from '../notificationActions';
import { SnackbarMessageVariants } from '../../../helpers/enums';
import { LanesKeyPerformanceIndicators } from '../../../interfaces/networkInsightsServiceInterfaces';
import ApiService from '../../../services/apiService';
import Endpoints from '../../../services/endpoints';

export const LANES_KEY_PERFORMANCE_INDICATORS_REQUEST = 'LANES_KEY_PERFORMANCE_INDICATORS_REQUEST';
export const LANES_KEY_PERFORMANCE_INDICATORS_SUCCESS = 'LANES_KEY_PERFORMANCE_INDICATORS_SUCCESS';
export const LANES_KEY_PERFORMANCE_INDICATORS_FAILURE = 'LANES_KEY_PERFORMANCE_INDICATORS_FAILURE';

const requestLanesKeyPerformanceIndicators = (): object => {
    return {
        type: LANES_KEY_PERFORMANCE_INDICATORS_REQUEST
    };
};

const receiveLanesKeyPerformanceIndicators = (json: object): object => {
    return {
        type: LANES_KEY_PERFORMANCE_INDICATORS_SUCCESS,
        payload: json
    };
};

const requestLanesKeyPerformanceIndicatorsFailed = (): object => {
    return {
        type: LANES_KEY_PERFORMANCE_INDICATORS_FAILURE
    };
};

const fetchLanesKeyPerformanceIndicators = (query: any): Function => {
    return async (dispatch: any): Promise<void> => {
        dispatch(requestLanesKeyPerformanceIndicators());

        try {
            const json: LanesKeyPerformanceIndicators = await ApiService.post(Endpoints.networkLanesKeyPerformanceIndicators, query, true);

            if (Object.keys(json).length > 0) {
                dispatch(receiveLanesKeyPerformanceIndicators(json));
            } else {
                dispatch(receiveLanesKeyPerformanceIndicators({}));
            }
        } catch (err) {
            dispatch(requestLanesKeyPerformanceIndicatorsFailed());
            dispatch(enqueueSnackbar({
                message: 'Error occurred while fetching key performance indicators.',
                variant: SnackbarMessageVariants.Error
            }));
        }
    };
};

export {
    fetchLanesKeyPerformanceIndicators
};
